oyc.AriAccordion = {
  selectors: {
    trigger: '[aria-expanded]'
  },

  init: function () {
    const triggers = document.querySelectorAll(this.selectors.trigger);

    triggers.forEach(trigger => {
      // Set initial state if not already set
      if (trigger.getAttribute('aria-expanded') === null) {
        trigger.setAttribute('aria-expanded', 'false');
      }

      // Get the controlled element ID
      const controlsId = trigger.getAttribute('aria-controls');
      if (!controlsId) return;

      const content = document.getElementById(controlsId);
      if (!content) return;

      // Set initial state of content
      this.setContentState(content, trigger.getAttribute('aria-expanded') === 'true');

      // Add click event
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleAccordion(trigger, content);
      });
    });
  },

  toggleAccordion: function (trigger, content) {
    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
    const newState = !isExpanded;

    // Update trigger state
    trigger.setAttribute('aria-expanded', newState.toString());

    // Update content state
    this.setContentState(content, newState);
  },

  setContentState: function (content, isExpanded) {
    if (isExpanded) {
      content.removeAttribute('hidden');
      content.style.display = 'block'
    } else {
      // After animation completes, hide and reset
      content.setAttribute('hidden', '');
      content.style.display = 'none';
    }
  },

};
